import React, { useState } from 'react';
import { Section } from '../section';
export function Template(props) {
    const { awaitCss } = props;
    if (awaitCss) {
        React.createElement(TemplateContentSuspended, Object.assign({}, props));
    }
    return React.createElement(TemplateContent, Object.assign({}, props));
}
const TemplateContent = ({ css, postId, children, sections }) => {
    return React.createElement("div", { className: `elementor elementor-${postId}` },
        css && React.createElement("link", { rel: "stylesheet", href: css }), sections === null || sections === void 0 ? void 0 :
        sections.map(section => React.createElement(Section, Object.assign({ key: section.id }, section), children)));
};
const TemplateContentSuspended = ({ css, postId, children, sections }) => {
    const [cssLoaded, setCssLoaded] = useState(css === null ? true : false);
    return React.createElement("div", { className: `elementor elementor-${postId}` },
        css && React.createElement("link", { rel: "stylesheet", href: css, onLoad: () => { setCssLoaded(true); } }),
        cssLoaded && (sections === null || sections === void 0 ? void 0 : sections.map(section => React.createElement(Section, Object.assign({ key: section.id }, section), children))));
};
